import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';

// 모달 루트 DOM 요소를 가져옵니다. (index.html에 <div id="modal-root"></div> 필요)
const modalRoot = document.getElementById('modal-root');

// 스타일 객체
const styles = {
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        backgroundColor: 'rgba(13, 4, 45, 0.9)', // 어두운 배경색 (유지)
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1200,
    },
    // --- ▼ [수정] 레이어 팝업 디자인 적용: 흰색 카드 형태로 변경 ---
    modalContent: {
        background: '#FFFFFF', // 컨텐츠 배경을 흰색으로 변경
        width: '300px', // 모바일 최적화를 위해 너비 지정
        padding: '32px 24px 24px', // 상하좌우 여백 조정
        borderRadius: '12px', // 모서리 둥글게
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)', // 그림자 추가
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '28px', // 요소 간 간격 조정
        position: 'relative',
    },
    // --- ▲ [수정] ---
    qrImagePlaceholder: {
        width: '240px',
        height: '240px',
        backgroundColor: 'white',
        borderRadius: '8px',
        border: '1px solid #EEEEEE', // 흰 배경에 경계선 추가 (선택적)
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        color: '#333',
    },
    // --- ▼ [추가] 팝업 타이틀 스타일 ---
    titleText: {
        fontFamily: 'Pretendard',
        fontWeight: 700, // 볼드
        fontSize: '20px',
        color: '#333333', // 어두운 색으로 변경
        textAlign: 'center',
        marginBottom: '-10px', // QR 코드와의 간격 조정
    },
    // --- ▲ [추가] ---
    // --- ▼ [수정] 타이머 텍스트 스타일: 크고 눈에 띄게 변경 ---
    timerText: {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        fontSize: '24px',
        color: '#1335B7', // 프로젝트 강조 색상 사용 (예시)
        textAlign: 'center',
    },
    // --- ▲ [수정] ---
    // 닫기 버튼 스타일
    // --- ▼ [수정] 닫기 버튼 스타일: 흰 배경에 맞춰 색상과 위치 조정 ---
    closeButton: {
        position: 'absolute',
        top: '12px', // 상단 여백
        right: '12px', // 우측 여백
        background: 'none',
        border: 'none',
        color: '#999999', // 닫기 버튼 색상을 어두운 회색으로 변경
        fontSize: '24px',
        fontWeight: 300,
        cursor: 'pointer',
        padding: '8px', // 클릭 영역 확보
        lineHeight: 1,
    },
    // --- ▲ [수정] ---
    // --- ▼ [추가] 안내 텍스트 스타일 ---
    instructionText: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        fontSize: '14px',
        color: '#666666', // 중간톤 회색
        textAlign: 'center',
        marginTop: '-20px', // 타이머와의 간격 조정
    }
    // --- ▲ [추가] ---
};

function QrModal({ show, onClose, qrImage }) {
    const [qrTimer, setQrTimer] = useState(null);

    // 모달 표시 상태 변경 시 타이머 설정/리셋
    useEffect(() => {
        if (show) {
            setQrTimer(20); // 20초 타이머 시작
        } else {
            setQrTimer(null); // 모달 닫히면 타이머 리셋
        }
    }, [show]);

    // 타이머 카운트다운 로직
    useEffect(() => {
        if (qrTimer === 0) {
            onClose(); // 모달 닫기 함수 호출
            return;
        }

        if (qrTimer === null || qrTimer < 0) {
            return;
        }

        const intervalId = setInterval(() => {
            setQrTimer(prevTimer => prevTimer - 1);
        }, 1000);

        return () => clearInterval(intervalId);

    }, [qrTimer, onClose]);

    // show가 false면 아무것도 렌더링하지 않음
    if (!show) {
        return null;
    }

    // 포탈을 사용하여 모달 렌더링
    return ReactDOM.createPortal(
        <div style={styles.modalOverlay} /* onClick 제거 유지 */ >
            <div style={styles.modalContent} onClick={(e) => e.stopPropagation()} /* 컨텐츠 클릭 시 전파 방지 유지 */ >
                {/* 닫기 버튼 */}
                <button style={styles.closeButton} onClick={onClose}>
                    &times;
                </button>

                {/* --- ▼ [추가] 팝업 타이틀 추가 --- */}
                <p style={styles.titleText}>QR 코드 입장</p>
                {/* --- ▲ [추가] --- */}

                {/* QR 코드 표시 영역 (실제 QR 생성/표시 로직 필요) */}
                <div style={styles.qrImagePlaceholder}>
                    {qrImage ? (
                        <img
                            src={qrImage}
                            alt="QR Code"
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                    ) : (
                        "QR 코드 생성 중..."
                    )}
                </div>

                {/* 타이머 표시 및 안내 텍스트 */}
                {qrTimer !== null && (
                    <>
                        <p style={styles.timerText}>
                            {String(qrTimer % 60).padStart(2, '0')}초
                        </p>
                        {/* --- ▼ [추가] 안내 텍스트 추가 --- */}
                        <p style={styles.instructionText}>
                            남은 시간 동안 QR 코드를 스캔해 주세요.
                        </p>
                        {/* --- ▲ [추가] --- */}
                    </>
                )}
            </div>
        </div>,
        modalRoot
    );
}

export default QrModal;